export const PLATFORM_TYPES = [
  {
    value: 'moored_buoy',
    label: 'Moored Buoy',
  },
  {
    value: 'tower',
    label: 'Tower',
  },
  {
    value: 'fixed',
    label: 'Fixed',
  },
  {
    value: 'drifter',
    label: 'Drifter',
  },
  {
    value: 'glider',
    label: 'Glider',
  },
];

export const COLLECTION_STATUSES = [
  {
    collection_status: 'active',
    value: 'activated',
    label: 'Deployed',
    description: 'Platform marked as activated from Platform Management Web Console',
  },
  {
    collection_status: 'inactive',
    value: 'decommissioned',
    label: 'Decommissioned',
    description: 'Platform marked as decommissioned from Platform Management Web Console',
  },
  {
    collection_status: 'inactive',
    value: 'recovered',
    label: 'Recovered',
    description: 'Platform marked as recovered from Platform Management Web Console',
  },
  {
    collection_status: 'testing',
    value: 'testing',
    label: 'Testing',
    description: 'Platform marked as testing from Platform Management Web Console',
  },
];
// TODO: use these in PlatformEvent component
// Potential TODO: define these in backend configuration for a single source of truth
